"use client";

import dynamic from "next/dynamic";
import type { PageDoc, PageMetadata } from "@/lib/pages/schema";
import type { PickerImage } from "@/lib/pages/assets";

/**
 * Thin client boundary that lazily pulls in the editor.
 *
 * `ssr: false` + the dynamic import keep Puck (and its CSS) in a chunk that is
 * only fetched in edit mode — the public homepage is LCP/SEO-critical and must
 * not carry the editor.
 */
const PageEditor = dynamic(() => import("./PageEditor"), {
  ssr: false,
  loading: () => <p style={{ padding: 24 }}>Loading editor…</p>,
});

type Props = {
  doc: PageDoc;
  metadata: PageMetadata;
  images: PickerImage[];
  locales: string[];
  defaultLocale: string;
  initialLocale: string;
};

export default function PageEditorLoader(props: Props) {
  return <PageEditor {...props} />;
}
